import React, { useState } from 'react';
import { useSocial } from '../../context/SocialContext';
import { Heart, MessageCircle, Share2, Filter, Search, SortDesc } from 'lucide-react';
const Community: React.FC = () => {
  const {
    posts,
    likePost
  } = useSocial();
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const filteredPosts = searchTerm ? posts.filter(post => post.description.toLowerCase().includes(searchTerm.toLowerCase())) : posts;
  return <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-920">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#E84118] to-[#c83616] rounded-lg p-6 md:p-8 text-white mb-6 md:mb-8" data-id="element-921">
        <h1 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4" data-id="element-922">
          Community
        </h1>
        <p className="text-base md:text-lg opacity-90" data-id="element-923">
          See what others are eating and sharing in your area
        </p>
      </div>
      {/* Search and filters */}
      <div className="bg-white rounded-lg shadow-md p-4 mb-6" data-id="element-924">
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-925">
          <div className="relative flex-1" data-id="element-926">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-927">
              <Search size={18} className="text-gray-400" data-id="element-928" />
            </div>
            <input type="text" placeholder="Search posts..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-929" />
          </div>
          <div className="flex gap-2" data-id="element-930">
            <div className="relative" data-id="element-931">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-932">
                <Filter size={16} className="text-gray-400" data-id="element-933" />
              </div>
              <select className="pl-9 pr-8 py-2 border border-gray-300 rounded-md appearance-none bg-white focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-934">
                <option value="all" data-id="element-935">All Posts</option>
                <option value="popular" data-id="element-936">Most Popular</option>
                <option value="recent" data-id="element-937">Most Recent</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" data-id="element-938">
                <SortDesc size={16} className="text-gray-400" data-id="element-939" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Posts Feed */}
      <div className="space-y-6" data-id="element-940">
        {filteredPosts.length === 0 ? <div className="bg-white rounded-lg shadow-md p-8 text-center" data-id="element-941">
            <p className="text-gray-500 mb-2" data-id="element-942">
              {searchTerm ? 'No posts match your search.' : 'No posts yet. Be the first to share!'}
            </p>
            {searchTerm && <button onClick={() => setSearchTerm('')} className="text-[#E84118] text-sm hover:underline" data-id="element-943">
                Clear search
              </button>}
          </div> : <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-944">
              {filteredPosts.map((post, index) => <div key={post.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-945">
                  <img src={post.image} alt="Food" className="w-full h-48 md:h-56 object-cover" data-id="element-946" />
                  <div className="p-4" data-id="element-947">
                    <div className="flex items-center mb-3" data-id="element-948">
                      <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center mr-3" data-id="element-949">
                        {post.userName.charAt(0)}
                      </div>
                      <div data-id="element-950">
                        <div className="font-medium" data-id="element-951">{post.userName}</div>
                        <div className="text-xs text-gray-500" data-id="element-952">
                          {post.createdAt.toLocaleDateString()}
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-700 mb-4 line-clamp-3" data-id="element-953">
                      {post.description}
                    </p>
                    <div className="flex items-center space-x-6" data-id="element-954">
                      <button onClick={() => likePost(post.id)} className="flex items-center text-gray-600 hover:text-[#E84118] transition-colors" data-id="element-955">
                        <Heart size={18} className="mr-1" data-id="element-956" />
                        <span data-id="element-957">{post.likes}</span>
                      </button>
                      <button className="flex items-center text-gray-600" data-id="element-958">
                        <MessageCircle size={18} className="mr-1" data-id="element-959" />
                        <span data-id="element-960">{post.comments}</span>
                      </button>
                      <button className="flex items-center text-gray-600" data-id="element-961">
                        <Share2 size={18} className="mr-1" data-id="element-962" />
                        <span data-id="element-963">Share</span>
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
            {filteredPosts.length > 4 && <div className="text-center mt-8" data-id="element-964">
                <button className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-965">
                  Load More
                </button>
              </div>}
          </>}
      </div>
    </div>;
};
export default Community;